import React from 'react';
import { getSafeDisplayName } from '../utils/profanityFilter';

export default function Profile({ user }) {
  // DISABLED: Login check - allow guest users
  // if (!user) {
  //   return (
  //     <div style={{ padding: 24 }}>
  //       <h2>Profile</h2>
  //       <p>Please sign in to view your profile.</p>
  //     </div>
  //   );
  // }
  
  // Ensure user exists (use mock if not provided)
  const displayUser = user || {
    uid: 'guest-user',
    email: 'guest@fidora.com',
    displayName: 'Guest User',
    isAnonymous: true
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Profile</h2>
      <div style={{ marginTop: 12 }}>
        <p><strong>Name:</strong> {getSafeDisplayName(displayUser.displayName)}</p>
        <p><strong>Email:</strong> {displayUser.email}</p>
        {displayUser.photoURL && (
          <img src={displayUser.photoURL} alt="avatar" style={{ width: 96, height: 96, borderRadius: 12, marginTop: 8 }} />
        )}
        {displayUser.isAnonymous && (
          <p style={{ marginTop: 12, color: '#888', fontStyle: 'italic' }}>Guest Mode - Sign in to save your profile</p>
        )}
      </div>
    </div>
  );
}


